module.exports = __webpack_public_path__ + "static/media/lo-que-sea.0b0c9a38.png";